<template>
    <div class="fixed-scroller">
        <div class="v-alert w-900" style="position: absolute;">
            <header><p>Ad {{ ad.title }}</p><div class="x" @click="emit('exit')"></div></header>
            <div class='stats-ads box-main'>
                <div class="ads-spins box box-1">
                    <div class="box-container">
                        <p>Spins</p>
                        <div v-for="spin in spins" class="box-item ad-spin-item">
                            <p class="td-ulb ellip" @click="getCustomer(customer_id)">{{ spin.name }}</p>
                            <p class="ta-r mr-10">{{ spin.qty }}</p>
                            <p>{{ spin.date }}</p>
                        </div>
                    </div>
                </div>
                <div class="redeem-dates box box-2">
                    <div class="box-container">
                    <p>Redemptions</p>
                        <div v-for="redeem in redeems" class="box-item redeem-item">
                            <p class="td-ulb ellip" @click="getCustomer(redeem._id)">{{ redeem.name }}</p>
                            <p class="ta-r mr-10">{{ redeem.qty }}</p>
                            <p>{{ redeem.date }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <component v-if="component" :is="component" @emit="emit" :item="item" style="z-index: 30;"/>
    </div>
</template>

<script>

import { format } from 'date-fns'
import WebSoc from '../utils/WebSoc.js';
import EditMember from '../components/editMember.vue';
import { mapActions } from 'vuex';

export default {
    name: 'stats-ads',
    props: ['ad'],
    components: {
        EditMember
    },
    computed: {
        client_id () { return this.$store.state.client_id },
        db () { return this.$store.state.client_id+'-customers' }
    },
    data () {
        return {
            component: '',
            item: false,
            redeems: [],
            spins: [],
            format,
            customers: []
        }
    },
    mounted () {
        var ad = this.ad;
        var customer_ids = Object.keys(ad.unique || {}).map(customer_id => { return { _id: customer_id }});
        customer_ids.length > 0 && WebSoc.SEND('search', { DB: this.db, find: { $or: customer_ids }, project: { name: 1 } },customers => {
            this.customers = customers;
            /*
            this.redeems = this.makeDitems(ad.dRedeem);
            console.log('this.redeems',this.redeems);
            this.spins = this.makeDitems(ad.dRotate);
            console.log('this.spins',this.spins);
            */
            if ( ad.dLinked ) {
                this.makeDitems(ad.dLinked).then(items => {
                    this.redeems = items;
                })
            } else {
                this.makeDitems(ad.dRedeem).then(items => {
                    this.redeems = items;
                });
            }
           this.makeDitems(ad.dRotate).then(items => {
               this.spins = items;
           })
        });
    },
    methods: {
        makeDitemsX ( dItem ) {
            var customers = this.customers;
            return Object.keys(dItem || {}).reduce((p,customer_id) => {
                var item = dItem[customer_id];
                var customer = customers.find(c => c._id == customer_id) || { name: 'no name' }
                customer.qty = item.length;
                customer.customer_id = item._id;
                if ( item[0] ) { customer.date = format(item[0],'dd/MM/yy HH:mm'); }
                if ( item[1] ) { customer.date += ' - '+format(item[item.length  - 1],'dd/MM/yy HH:mm') }
                customer.start = item[item.length-1] || Infinity;
                p.push(customer);
                return p;
            },[]).sort((a,b) => a.date < b.date ? 1 : -1);
        },
        getCustomer ( customer_id ) {
            WebSoc.SEND('get',{ DB: this.db, _id: customer_id },customer => {
                this.item = customer;
                this.component = 'EditMember';
                console.log('customer',customer);
            });
        },
        getName ( customer_id ) {
            var customer = this.customers.find(c => c._id == customer_id);
            return customer ? customer.name : 'no name';
        },
        emit( action ) {
            if ( action.t == 'edit-member' && action.action == 'exit' ) {
                this.item = false;
                this.component = '';
                return;
            }
            this.$emit('emit',{ t: 'stats-ads', item: this.ad, action });
        },
        ...mapActions([
            'makeDitems'
        ])
    }
}

</script>

<style scopped lang="scss">
.ad-spin-item {
    grid-template-columns: 140px 40px 1fr;
}
.redeem-item {
    grid-template-columns: 140px 40px 1fr;
}
</style>